<template>
  <v-card flat>
    <v-card-title class="p-0 ma-1"> Transaction Jobs </v-card-title>
    <v-expansion-panels popout class="my-3">
      <!-- <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Push Transaction by Pin Number
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p>
            Please provide specific transaction pin number and click on "Push".
          </p>
          <v-form v-model="valid" ref="txnbyPin">
            <v-row no-gutters>
              <v-col>
                <label class="my-0 labelFontsize">Pin Number</label>
                <v-text-field
                  v-model="pinNumber"
                  dense
                  outlined
                  required
                  :rules="fieldRequired"
                  class="rounded"
                  placeholder="Please enter Pin Number"
                ></v-text-field>
              </v-col>
              <v-col class="mt-5 ms-3 pa-0"
                ><v-btn depressed  color="primary" dense @click="pushtxnbyId()"
                  >Push</v-btn
                ></v-col
              >
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
      <!-- <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Commit Transaction
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <p>
                You can commit transaction by clicking on "Commit Transaction"
                button
              </p>
            </v-col>
            <v-col class="ms-3 pa-0 d-flex">
              <v-btn depressed  color="primary" dense @click="commitTxn()"
                >Commit Transaction</v-btn
              ></v-col
            >
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
      <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Get Transaction Status by Pin Number
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p>
            Please provide specific transaction pin number and click on "Get
            Transaction".
          </p>
          <v-form v-model="valid" ref="gettxnbyPin">
            <v-row no-gutters>
              <v-col>
                <label class="my-0 labelFontsize">Pin Number</label>
                <v-text-field
                  v-model="transpinNumber"
                  dense
                  outlined
                  required
                  :rules="fieldRequired"
                  class="rounded"
                  placeholder="Please enter Pin Number"
                ></v-text-field>
              </v-col>
              <v-col class="mt-5 ms-3 pa-0"
                ><v-btn depressed  color="primary" dense @click="gettxnbyId()"
                  >Get Transaction Status</v-btn
                ></v-col
              >
            </v-row>
          </v-form>
          <v-row v-if="transactionStatus" dense class="mt-3">
            <v-col cols="12">
              <div class="transaction-status-tags">
                <v-chip class="status-tag" color="primary" outlined>
                  <span class="status-tag__label">Partner Pin Number</span>
                  <span class="status-tag__value">
                    {{ transactionStatus.partner_pinnumber || "-" }}
                  </span>
                </v-chip>
                <v-chip class="status-tag" color="primary" outlined>
                  <span class="status-tag__label">Partner Status</span>
                  <span class="status-tag__value">
                    {{ transactionStatus.partner_status || "-" }}
                  </span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Push All Unpushed Trasanctions
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <p>
                You can push all unpushed transactions by clicking on "Push All
                Transactions"
              </p>
            </v-col>
            <v-col class="ms-3 pa-0 d-flex">
              <v-btn depressed  color="primary" dense @click="pushallTxn()"
                >Push All Transactions</v-btn
              ></v-col
            >
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
      <!-- <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Get All Transactions Status
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <p>
                You can get all transactions status by clicking on "Get All
                Transaction Status"
              </p>
            </v-col>
            <v-col class="ms-3 pa-0 d-flex">
              <v-btn depressed  color="primary" dense @click="getallTxnStatus()"
                >Get All Transaction Status</v-btn
              ></v-col
            >
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
      <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Calculate Transaction Earnings for Partner
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <p>
                You can able to trigger calculations for transaction earnings
                for partner by clicking on "Calculate"
              </p>
            </v-col>
            <v-col class="ms-3 pa-0 d-flex">
              <v-btn depressed  color="primary" dense @click="calculateTxn()"
                >Calculate</v-btn
              ></v-col
            >
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>
<script>
import alerts from "@/mixins/alerts";
import croneService from "@/services/CroneService/croneService.js";
export default {
  mixins: [alerts],
  data: () => ({
    pinNumber: "",
    transpinNumber: "",
    transactionStatus: null,
    loader: false,
    valid: false,
    fieldRequired: [(v) => !!v || "Required"],
  }),

  methods: {
    async pushtxnbyId() {
      if (this.$refs.txnbyPin.validate()) {
        this.$emit("showOverlay",true)
        try {
          const responseData = await croneService.pushTransPinNumber(this.pinNumber);
          if (responseData?.data?.status_code === 200) {
            this.$refs.txnbyPin.reset();
            this.$emit("showOverlay",false)
            this.showAlertSuccess(
              `Transaction Pushed : ${responseData.data.message}`
            );
          } else {
            this.$emit("showOverlay",false)
            this.showAlertError(
              `Transaction pushed : ${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`
            );
          }
        } catch (e) {
          this.$emit("showOverlay",false)
          console.log(e);
        }
      }
    },
    async calculateTxn() {
      this.$emit("showOverlay",true)
      try {
        const responseData = await croneService.getCalculateTxn();
        this.$emit("showOverlay",false)
        this.showAlertSuccess("Success");
        return responseData;
      } catch (e) {
        this.$emit("showOverlay",false)
        console.log(e);
      }
    },
    async commitTxn() {
      try {
        const responseData = await croneService.getCommitTrans();
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess("Success");
        } else {
          this.showAlertError("Failed: " + responseData.data.message);
        }
        return responseData.data?.data;
      } catch (e) {
        console.log(e);
      }
    },
    async gettxnbyId() {
      if (this.$refs.gettxnbyPin.validate()) {
        this.$emit("showOverlay",true)
        this.transactionStatus = null;
        try {
          const responseData = await croneService.getTransPinStatus(this.transpinNumber);
          if (responseData?.data?.status_code === 200) {
            this.transactionStatus = responseData?.data?.data?.[0] || null;
            this.$emit("showOverlay",false)
            this.$refs.gettxnbyPin.reset();
            this.showAlertSuccess(
              `Partner Pin Number : ${
                this.transactionStatus?.partner_pinnumber || "-"
              }, Partner Status : ${
                this.transactionStatus?.partner_status || "-"
              }`
            );
          } else {
            this.$emit("showOverlay",false)
            this.showAlertError(
              `Transaction Status :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`
            );
          }
          return responseData.data?.data;
        } catch (e) {
          this.$emit("showOverlay",false)
          console.log(e);
        }
      }
    },
    async pushallTxn() {
      try {
        const responseData = await croneService.getAllPushTrans();
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(responseData.data.message);
        }
        return responseData.data?.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getallTxnStatus() {
      try {
        const responseData = await croneService.getAllTransStatus();
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(responseData.data.message);
        }
        return responseData.data?.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style>
.v-expansion-panel {
  width: 500px !important;
}

.transaction-status-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-tag {
  border-radius: 18px !important;
  height: auto !important;
  padding: 6px 12px !important;
}

.status-tag__label {
  color: #6b7280;
  font-size: 12px;
  margin-right: 8px;
}

.status-tag__value {
  color: #111827;
  font-weight: 600;
}
</style>
